import { z } from 'zod'

export const CREDENTIAL_OPTIONS = ['MD', 'DO', 'NP', 'PA', 'DNP', 'PhD'] as const
export type CredentialType = (typeof CREDENTIAL_OPTIONS)[number]

export const stateLicenseSchema = z.object({
  state: z
    .string()
    .refine((v) => v.trim().length > 0, { message: 'State is required' }),
  license_number: z
    .string()
    .refine((v) => v.trim().length > 0, { message: 'License number is required' }),
})

export const onboardingCredentialsSchema = z.object({
  credentials: z.enum(CREDENTIAL_OPTIONS),
  npi: z
    .string()
    .min(1, 'NPI is required')
    .regex(/^\d{10}$/, 'NPI must be 10 digits'),
  state_licenses: z
    .array(stateLicenseSchema)
    .min(1, 'At least one state license is required'),
})

export type OnboardingCredentialsData = z.infer<typeof onboardingCredentialsSchema>
